// extracted by mini-css-extract-plugin
export default {"readonly-text":"ReadonlyInput_readonly-text__cm7h5","readonly-text_title":"ReadonlyInput_readonly-text_title__wU-zi"};